import { render, staticRenderFns } from "./eventManage.vue?vue&type=template&id=6f966d72&scoped=true&"
import script from "./eventManage.vue?vue&type=script&lang=js&"
export * from "./eventManage.vue?vue&type=script&lang=js&"
import style0 from "./eventManage.vue?vue&type=style&index=0&id=6f966d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f966d72",
  null
  
)

export default component.exports